export const CONFIG = {
  KINDE_DOMAIN: process.env.REACT_APP_KINDE_DOMAIN!,
  KINDE_CLIENT_ID: process.env.REACT_APP_KINDE_CLIENT_ID!,
  KINDE_CALLBACK_URL: process.env.REACT_APP_KINDE_CALLBACK_URL!,
  KINDE_LOGOUT_URL: process.env.REACT_APP_KINDE_LOGOUT_REDIRECT_URL,
  KINDE_CONNECTION_ID: process.env.REACT_APP_KINDE_CONNECTION_ID,
};
